import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-ter warnSettingTips" }
const _hoisted_2 = { style: {"margin-left":"4px"} }

import { ref, watch } from 'vue';
import { t } from '@/plugins/i18n';
import CommonDialog from '@/components/common/CommonDialog.vue';
import SvgIcon from '@/components/icons/SvgIcon.vue';
import { getStockNotifyConfig, saveStockNotifyConfig } from '@/apis/stock';
import store from '@/store';
import { ElMessage } from 'element-plus';

export default /*#__PURE__*/_defineComponent({
  props: ['visible'],
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props


const visible = ref(false);

const config = ref({
  configValue: 30
});

const rule = {
  configValue: [
    {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (value === '') {
          callback(new Error(t('必填')));
          return;
        }
        if (isNaN(value)) {
          callback(new Error(t('仅限数字')));
          return;
        }
        if (value < 0 || value > 100) {
          callback(new Error(t('必填')));
          return;
        }
        callback();
      }
    }
  ]
};

watch(
  () => props.visible,
  (val) => {
    val && getData();
  }
);
const getData = async () => {
  const res = await getStockNotifyConfig();
  if (res.code !== '0') {
    return;
  }
  config.value.configValue = Number(res.data);
};

const additionForm = ref();
const ok = async () => {
  const valid = await additionForm.value.validate(
    (valid: any, fields: any) => {}
  );
  if (!valid) {
    return;
  }
  const params = {
    configValue: config.value.configValue
  };
  const res = await saveStockNotifyConfig(params);
  if (res.code !== '0') {
    return;
  }
  ElMessage.success(t('修改成功'));
  emit('close');
};
const cancel = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: props.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((props.visible) = $event)),
    width: 700,
    onOk: ok,
    onCancel: cancel,
    title: _unref(t)('辅料不足提醒设置'),
    footer: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        style: {"margin-top":"10px"},
        class: "additionForm",
        ref: (_value, _refs) => {
          _refs['additionForm'] = _value
          additionForm.value = _value
        },
        rules: rule,
        model: config.value,
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('当单个辅料的良品数低于总数的'),
            prop: "configValue"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: config.value.configValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((config.value.configValue) = $event)),
                max: 99,
                min: 1,
                step: 1,
                "step-strictly": true,
                controls: false,
                style: {"width":"52px","margin-right":"10px"}
              }, null, 8, ["modelValue"]),
              _createTextVNode("% " + _toDisplayString(_unref(t)('时,进行提醒')), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SvgIcon, {
          style: {"font-size":"16px"},
          name: "Info"
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('建议设置在20%~50%之间')), 1)
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})